import React from 'react'
import { Row, Col } from 'react-bootstrap'
import { quantityCounterOperations } from '../../../models/cart.model';
import QuantityCounter from '../../Cart/CartItems/QuantityCounter'
import styleClasses from './OrderNameForm.module.scss';

interface IOrderNameForm{
    setQuantity?: (quantity:number) => void
    quantity?: number;
    madeFor?:string;
    setMadeForName?: (name:string) => void
    try2ComboPadding?: string;
    isRedeemedItem: boolean
}

export const OrderNameForm:React.FC<IOrderNameForm> = ({setQuantity, quantity, madeFor, setMadeForName, try2ComboPadding, isRedeemedItem}) => {

    const handleQuantityChangeWrapper = async (operation: quantityCounterOperations) => {
        let newQuantity = quantity
        if (operation === quantityCounterOperations.increase) {
            newQuantity = quantity + 1
        } else {
            newQuantity = quantity > 1 ? quantity - 1 : 1;
        }
        setQuantity(newQuantity);
      };

    return (
        <div className='mb-4'>
            <Row>
                <Col lg="4" md="5" xs="5" className={`pe-0  ${try2ComboPadding}`}>
                    <div className={`${styleClasses.item_detail_order_wrapper} `}>
                    <QuantityCounter 
                        itemDetailCounterStyle= {styleClasses.item_detail_counter} 
                        editQuantity = {handleQuantityChangeWrapper}
                        quantity={quantity}
                        disabled={isRedeemedItem}
                    />
                    </div>
                   
                </Col>
                <Col lg="8" md="7" xs="7" className='ps-1'>
                    <div className={`new_form_design my-0 ${styleClasses.order_name_field}`} >
                        <label className="f-s14 ls-normal lh-normal font-Visby-cf text-capitalize ms-1">
                            Made For
                        </label>
                        <input
                            name="name"
                            type="text"
                            className="form-control no-style"
                            onChange={(e) => {
                                if (e?.target?.value?.length <= 16) 
                                    setMadeForName(e?.target?.value)
                            }}
                            value={madeFor}
                        />
                    </div>
                </Col>

            </Row>

        </div>

    )
}
